const sharedUserFields = `
_id
createdAt
dateOfBirth
email
password
emailVerified
firstName
friendlyId
lastName
middleName
prefix
role
suffix
type
updatedAt
address {
  address1
  address2
  city
  country
  state
  zip
}
meta {
  active
  autoGenerated
  dateCreated
  emailVerificationToken
  emailVerificationTokenExpiration
  lastActivity
  lastUpdated
  notes
  status
  testData
  sso
  source
  onboardingStatus
}
leadFields {
  isLead
  status
  type
  source
  company
  title
  anticipatedAum
  advisor {
    _id
    firstName
    lastName
  }
  assignee {
    _id
    firstName
    lastName
  }
}
userSettings {
  preferredContactMethod
  defaultBoard
  pinnedBoards
  tableColumnPreferences {
    boardId
    columns {
      id
      source
      visible
      order
      width
    }
  }
  preferredTabByBoard {
    boardId
    tab
  }
  internalDashboard {
    defaultTab
  }
  slackNotificationsEnabled
  documentAuditPresets {
    assetType
    acquisitionMethod
    requiredCategories
  }
  metricsPreferences {
    boardId
    metrics {
      id
      visible
      order
    }
  }
}
contactInfo {
  businessPhone
  mobilePhone
  homePhone
  cellPhone
}
`;

const advisorUserFields = `
crd
firmCrd
firmName
userInvites {
  _id
  createdAt
  expectedEmail
  expectedFirstName
  expectedLastName
  inviteExpirationDate
  inviteStatus
  inviteType
}
advisedUsers {
  _id
  firstName
  lastName
  totals {
    date
    portfolioBalance
    cash
    stock
    crypto
    alternativeAssets
    other
  }
  documents {
    _id
    gridFsFileId
    createdAt
    fileName
    filePath
    fileType
    updatedAt
  }
}
entities {
  admin
  entity {
    ... on FirmEntity {
      _id
      entityName
    }
  }
}
`;

const labelUserFields = `
labels {
  _id
  name
  slug
  color
  category
}
`;

export { sharedUserFields, advisorUserFields, labelUserFields };
